export const LOCAL_ENV = 'dev';